import { useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import ErrorAlert from '../Alerts/ErrorAlert'
import ModalContent from './ModalContent'
import ModalHeader from './ModalHeader'
import ModalFooter from './ModalFooter'
import ModalContentWrapper from './ModalContentWrapper'
import ModalMainWrapper from './ModalMainWrapper'

export default function ConfirmDialog({ onConfirm, title, description }) {
    const skimModal = ModalStore((state) => state.skim)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    async function handleConfirm() {
        try {
            setLoading(true)
            setError('')
            await onConfirm()
            skimModal()
        } catch (e) {
            setError(
                e?.response?.data?.message ||
                    e?.message ||
                    'Something went wrong. Please try again.',
            )
        } finally {
            setLoading(false)
        }
    }

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size={'md'}>
                <ModalHeader title={title} />
                <ModalContent>
                    <div className="space-y-4">
                        <div>{description}</div>
                        {error && <ErrorAlert error={error} />}
                    </div>
                </ModalContent>
                <ModalFooter
                    onConfirm={handleConfirm}
                    confirmDisabled={loading}
                    cancelDisabled={loading}
                    confirmText={loading ? 'Working...' : 'Confirm'}
                />
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
